/**
 * Monkey user constant (client)
 * Reserved system user for the "Monkey" opponent.
 * Use for hiding remove button and any monkey-specific UI.
 */
export const MONKEY_USER_ID = 'monkey';

/** Avatar ID for the Monkey user (display only; not in AVATAR_IDS so users cannot pick it). */
export const MONKEY_AVATAR_ID = 'monkey' as const;
